export const CONTEXT_LIMITS = {
    VISIBLE_ROWS: 20,
    MAX_TEXT_CHARS: 1200,
    RUBRIC_CRITERIA: 12,
    RUBRIC_OPTIONS: 8,
};

export const PageTypes = {
    COURSE_DASHBOARD: 'course_dashboard',
    ASSIGNMENTS: 'assignments',
    ASSIGNMENT_CREATE: 'assignment_create',
    ASSIGNMENT_OVERVIEW: 'assignment_overview',
    ASSIGNMENT_EDIT: 'assignment_edit',
    GRADING: 'grading',
    ASSIGNMENT_PREVIEW: 'assignment_preview',
    SUBMISSIONS: 'submissions',
    SUBMISSION_DETAIL: 'submission_detail',
    PEOPLE: 'people',
    COURSE_SETTINGS: 'course_settings',
    RUBRICS: 'rubrics',
    UNKNOWN: 'unknown',
};

export const PageViews = {
    SUBMISSIONS: 'submissions',
    GRADING_INSIGHTS: 'grading_insights',
};

export const ScopeTypes = {
    USER: 'user',
    COURSE: 'course',
    ASSIGNMENT: 'assignment',
};

export const RouteResources = {
    ASSIGNMENTS: 'assignments',
    PEOPLE: 'people',
    COURSE_SETTINGS: 'course-settings',
    RUBRICS: 'rubrics',
};

export const AssignmentSections = {
    NEW: 'new',
    EDIT: 'edit',
    GRADING: 'grading',
    PREVIEW: 'preview',
    SUBMISSIONS: 'submissions',
};

export const RowTypes = {
    ASSIGNMENTS: 'assignments',
    SUBMISSIONS: 'submissions',
    GRADES: 'grades',
    PEOPLE: 'people',
    RUBRICS: 'rubrics',
};

export const SubmissionStatuses = {
    FAILED: 'failed',
    GRADED: 'graded',
    NEEDS_REVIEW: 'needs_review',
    IMPORTED: 'imported',
};

export const AssignmentStatuses = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DRAFT: 'draft',
};

export const GradeStatuses = {
    DRAFT: 'draft',
    SUGGESTED: 'suggested',
    PUSHED: 'pushed',
};
